import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=97d378cc&scoped=true&"
import script from "./SummarySection.vue?vue&type=script&lang=js&"
export * from "./SummarySection.vue?vue&type=script&lang=js&"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=97d378cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d378cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLabel,VRow})
